if (!customElements.get('s19-sort')) {
  customElements.define(
    's19-sort',
    class S19Sort extends HTMLElement {
      connectedCallback() {
        this.details = this.querySelector('details');
        this.summary = this.querySelector('summary');
        this.links = Array.from(this.querySelectorAll('a'));
        this.onOutside = (event) => {
          if (!this.contains(event.target)) this.close();
        };

        this.details.addEventListener('toggle', () => {
          this.summary.setAttribute('aria-expanded', this.details.open);
          if (this.details.open) {
            document.addEventListener('click', this.onOutside);
            (this.links.find((link) => link.hasAttribute('aria-current')) || this.links[0]).focus();
          } else {
            document.removeEventListener('click', this.onOutside);
          }
        });
        this.summary.setAttribute('aria-expanded', 'false');
        this.addEventListener('keydown', (event) => this.onKey(event));
      }

      disconnectedCallback() {
        document.removeEventListener('click', this.onOutside);
      }

      onKey(event) {
        if (event.key === 'Escape' && this.details.open) {
          event.preventDefault();
          this.close();
          this.summary.focus();
          return;
        }
        if (event.key !== 'ArrowDown' && event.key !== 'ArrowUp') return;
        event.preventDefault();
        if (!this.details.open) {
          this.details.open = true;
          return;
        }
        const step = event.key === 'ArrowDown' ? 1 : -1;
        const index = this.links.indexOf(document.activeElement);
        this.links[(index + step + this.links.length) % this.links.length].focus();
      }

      close() {
        this.details.open = false;
      }
    }
  );
}
